export default __webpack_public_path__ + "static/media/orangeM.76cd5727.svg";